<template>
  <v-autocomplete
    v-model="selected"
    :items="selectorItems"
    item-value="id"
    item-text="name"
    label="Формы"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    :rules="rule"
    multiple
    @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span v-if="selected.length === 1" class="mr-2 mt-n1" style="max-width: 130px;">
        <v-chip small >
          <span class="sliced-name">{{ selectorItems.find(v => v.id === selected[0]).name }}</span>
        </v-chip>
      </span>

      <span v-else-if="selected.length > 1" class="mt-n1">
        <v-chip small style="max-width: 130px;">
          <span class="sliced-name">{{ selectorItems.find(v => v.id === selected[0]).name }}</span>
        </v-chip>
        <span class="grey--text caption">(+{{selected.length - 1}})</span>
      </span>
    </template>

    <!-- Убираем чекбоксы в меню -->
    <template #item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <!-- Строка "Выбрать всё" -->
    <template #prepend-item>
      <v-list-item ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{toggleAllText}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  
  </v-autocomplete>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'FormSelector',
  props: {
    value: {
      required: true,
    },
    associated: Array,
    noRules: Boolean,
  },

  data() {
    return {
      allSelectorItems: [],
      selectorItems: [],
      rule: [
        v => {
          if (this.noRules) return true
          else {
            return !!v.length || 'Данное поле обязательно'
          }
        }
      ],
    }
  },

  computed: {
    ...mapGetters({}),

    selected: {
      get() {
        return this.value;
      },
      set(selected) {
        this.$emit('input', selected);
      },
    },

    allItems() {
      return this.selected.length === this.selectorItems.length
    },

    moreItems() {
      return this.selected.length !== 0 && this.selected.length < this.selectorItems.length
    },

    icon() {
      if (this.allItems) return "mdi-close-box";
      if (this.moreItems) return "mdi-plus-box";
      return "mdi-checkbox-blank-outline";
    },

    toggleAllText() {
      if (this.allItems) return "Отменить все";
      if (this.moreItems) return "Выбрать все";
      return "Выбрать все";
    },
  },

  watch: {
    associated(val) {
      // Кидаем сюда массив IDшников форм, которые приходят из селектора хелперов
      if (val.length) { 
        // если массив не пустой оставляем в опциях только те что прищли
        this.selectorItems = this.allSelectorItems.filter(item => val.includes(item.id))
        this.selected = val
      } else {
        // иначе показываем ВСЕ опции
        this.selectorItems = window.structuredClone(this.allSelectorItems)
      }
    },
  },

  methods: {
    ...mapActions({
      loadGraph: 'graphql/loadGraph',
    }),

    refresh() {
      this.selected = []
      this.selectorItems = this.allSelectorItems
    },

    toggleAll() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.selected = []
        } else {
          this.selected = this.selectorItems.map(v => v.id)
        }
      });
    },

    test() {

    }
  },

  async mounted() {
    let q = `forms {
      data {
        id
        title
      }
    }`

    let res = await this.loadGraph(q)

    this.allSelectorItems = res.forms.data.map(form => ({
      id: form.id,
      name: form.title
    }))

    this.selectorItems = window.structuredClone(this.allSelectorItems)

  },
}
</script>

<style scoped lang="scss">
.sliced-name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>